import { snapshot } from 'valtio'
import { cardAddProxy } from './cardAddProxy'

function buildConvergeCCTokenParams (): { [key in string]: string | number } {
  const { converge, formValues } = snapshot(cardAddProxy)

  return {
    ssl_add_token: 'Y',
    ssl_avs_address: formValues.streetAddressOne ?? '',
    ssl_avs_zip: formValues.postalCode ?? '',
    ssl_card_present: 'N',
    ssl_first_name: formValues.firstName ?? '',
    ssl_last_name: formValues.lastName ?? '',
    ssl_transaction_type: 'ccgettoken',
    ssl_txn_auth_token: converge.sessionToken ?? ''
  }
}

export interface ConvergePaymentApprovalType {
  // Example
  // {
  //   "ssl_merchant_initiated_unscheduled": "N",
  //   "ssl_issuer_response": "00",
  //   "ssl_partner_app_id": "01",
  //   "ssl_card_number": "40**********0002",
  //   "ssl_oar_data": "010010432209271725370000047554200000000000576014127017104322",
  //   "ssl_transaction_type": "SALE",
  //   "ssl_result": "0",
  //   "ssl_txn_id": "270921AD3-8D80AA06-D012-4207-B9C0-3ED2D503604E",
  //   "ssl_avs_response": "Z",
  //   "ssl_approval_code": "576014",
  //   "ssl_amount": "2.00",
  //   "ssl_txn_time": "09/27/2021 01:25:37 PM",
  //   "ssl_account_balance": "0.00",
  //   "ssl_ps2000_data": "A7512706273705523154VE",
  //   "ssl_exp_date": "1223",
  //   "ssl_result_message": "APPROVAL",
  //   "ssl_card_short_description": "VISA",
  //   "ssl_get_token": "Y",
  //   "ssl_token_response": "SUCCESS",
  //   "ssl_card_type": "CREDITCARD",
  //   "ssl_cvv2_response": "M",
  //   "ssl_token": "4692536310000002",
  //   "ssl_add_token_response": "Card Updated"
  // }
  /* eslint-disable camelcase */
  ssl_account_balance: string
  ssl_add_token_response: string
  ssl_amount: string
  ssl_approval_code: string
  ssl_avs_response: string
  ssl_card_number: string
  ssl_card_short_description: string
  ssl_card_type: string
  ssl_cvv2_response: string
  ssl_exp_date: string
  ssl_get_token: string
  ssl_issuer_response: string
  ssl_merchant_initiated_unscheduled: string
  ssl_oar_data: string
  ssl_partner_app_id: string
  ssl_ps2000_data: string
  ssl_result: string
  ssl_result_message: string
  ssl_token: string
  ssl_token_response: string
  ssl_transaction_type: string
  ssl_txn_id: string
  /* eslint-enable camelcase */
}

interface ConvergePaymentDeclinedType {
  // Example: {
  //   errorCode: "4009"
  //   errorMessage: "The field Postal Code (ssl_avs_zip) required but not supplied in the authorization request."
  //   errorName: "Required Field Not Supplied"
  // }

  errorCode: string
  errorMessage: string
  errorName: string
}

export async function executeConvergeOpenLightbox (): Promise<ConvergePaymentApprovalType> {
  return await new Promise((resolve, reject) => {
    cardAddProxy.apiCallConvergeGetToken.error = null
    cardAddProxy.apiCallConvergeGetToken.loading = true
    const options = {
      cssOverride: 'html, body {background-color: rgba(0, 0, 0, 0)} ' +
          '.hpm-content {box-shadow: unset; padding:0; margin-top: unset;} ' +
          'md-card {box-shadow: unset;} ' +
          ' .layout-padding {padding:0} ' +
          'div span.ng-binding:before {content:"Save Card"; color:#FFF} ' +
          'button.md-button.md-primary.md-raised {background-color:#0250C5; color:#FFF}' +
          'button.md-button.md-primary.md-raised:hover {background-color:#2A5EC1} ' +
          'button.md-button.md-primary.md-raised:active {background-color:#4878CB} ' +
          'button.md-button.md-primary.md-raised:disabled {background-color:#92B1E1} ' +
          'md-input-container .md-input {border-color: #DADADA}' +
          'md-input-container label {color:#AAAAAA} ' +
          'md-dialog-content div h3 {text-align:center}' +
          'md-dialog-content div h3:before {content:"Unable to save card"; white-space: pre-wrap} ' +
          'md-dialog-content div h3:after {content:" \\A Check your information is correct and try again"; white-space: pre-wrap; font-weight: normal} ' +
          'md-dialog-content div h3 div {display:none} ' +
          'md-dialog md-dialog-actions button.md-button:nth-of-type(2) {color:white !important; background-color: #ff0000} ' +
          'md-dialog md-dialog-actions button.md-button:first-of-type {display:none} ' +
          'md-dialog md-dialog-actions {justify-content:center} ',

      frame: document.getElementById('id_payment')
    }
    //  'md-dialog md-dialog-actions {justify-content:center} ' +
    window.PayWithConverge.open(
      buildConvergeCCTokenParams(),
      {
        onApproval: (response: ConvergePaymentApprovalType) => {
          cardAddProxy.converge.cardToken = response.ssl_token
          cardAddProxy.converge.cardNumber = response.ssl_card_number
          cardAddProxy.converge.cardBrand = response.ssl_card_short_description
          cardAddProxy.converge.cardType = response.ssl_card_type
          cardAddProxy.converge.expDate = response.ssl_exp_date
          cardAddProxy.apiCallConvergeGetToken.loading = false
          resolve(response)
        },
        onCancelled: (error: any) => {
          cardAddProxy.apiCallConvergeGetToken.loading = false
          cardAddProxy.apiCallConvergeGetToken.error = 'Cancelled by user'
          cardAddProxy.displaySlideOverCAP = true
          reject(error)
        },
        onDeclined: (response: ConvergePaymentDeclinedType) => {
          cardAddProxy.apiCallConvergeGetToken.loading = false
          cardAddProxy.apiCallConvergeGetToken.error = response.errorMessage
          reject(response)
        },
        onError: (error: any) => {
          console.log(error.message)
          cardAddProxy.apiCallConvergeGetToken.loading = false
          cardAddProxy.apiCallConvergeGetToken.error = error.message
          reject(error)
        },
        onReady: () => {
          cardAddProxy.iframeLoading = false
        }
      }, options
    )
  })
}
